import React from 'react';
import moment from 'moment';
import { MyTag } from '@laigu/component';
import EventIcon from './event-icon';
import style from './index.less';
import SystemTag from '../system-tag';

const MessageEventEvalution = props => {
  const { data = {} } = props;
  const { action, content = {}, time, agentName } = data;
  const { added_tag = [], deleted_tag = [] } = content;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{agentName}</li>
        <li>{'修改对话标签'}</li>
      </ul>
      <div className={style['event-border']} />
      <div className={style['evaluation-content']}>
        <ul>
          {added_tag.length > 0 ? (
            <li>
              <span style={{ marginRight: '8px' }}>{'添加对话标签'}</span>
              {added_tag.map(val => (
                <SystemTag key={val.id} data={val} />
              ))}
            </li>
          ) : null}
          {deleted_tag.length > 0 ? (
            <li style={{ paddingTop: added_tag.length > 0 ? '10px' : '0px' }}>
              <span style={{ marginRight: '8px' }}>{'删除对话标签'}</span>
              {deleted_tag.map(val => (
                <SystemTag key={val.id} data={val} />
              ))}
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default MessageEventEvalution;
